import React, { Component } from 'react';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';


import createStore from './state/createStore';
import { version } from '../package.json';

import Search from './components/Search/Search';
import Home from './components/Home/Home';
import FlightsHome from './components/FlightsHome/FlightsHome';
import FlightsHomeDates from './components/FlightsHomeDates/FlightsHomeDates';
import Calendar from './components/Calendar/Calendar';
import Passengers from './components/Passengers/Passengers';
import Seats from './components/Seats/Seats';
import Purchase from './components/Purchase/Purchase';
import Confirmation from './components/Confirmation/Confirmation';
import FlightPage from './components/FlightPage/FlightPage';
import Footer from './components/Footer/Footer';
import FlightBrowse from './components/FlightBrowse/FlightBrowse';

import './App.css';
import "../node_modules/video-react/dist/video-react.css";
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Loading from './components/Loading/Loading';

const history = createBrowserHistory();
const store = createStore({ history });

class App extends Component {
  componentDidMount() {
    console.log(`Airbnb Zelda Version: ${version}`);
  }

  render() {
    return (
      <Provider store={store}>
        <Router >
          <ScrollToTop>
            <div className="App">

              {/* Render the loader for these routes */}  
              <Route exact path="/flights/outbound" component={Loading} />
              <Route exact path="/flights/return" component={Loading} />
              <Route exact path="/flights/browse" component={Loading} />
              <Route exact path="/flights" component={Loading} />
              <Route path="/flight" component={Loading} />
              <Route path="/flights/review" component={Loading} />

              {/* render the search bar on specified pages */}
              <Route exact path="/" component={Search} />
              <Route exact path="/flights" component={Search} />
              <Route exact path="/flights/outbound" component={Search} />
              <Route exact path="/flights/return" component={Search} />
              <Route exact path="/flights/browse" component={Search} />

              {/* render the footer on specified pages */}
              <Route exact path="/" component={Footer} />
              <Route exact path="/flights/confirmation" component={Footer} />
              <Route exact path="/flights" component={Footer}/>
              <Route exact path="/flights/outbound" component={Footer}/>
              <Route exact path="/flights/return" component={Footer}/>
              <Route exact path="/flights/browse" component={Footer}/>

              {/* render the main content page */}
              <Switch>   
                <Route exact path="/" component={Home} />
                <Route path="/flights/calendar" component={Calendar} />
                <Route path="/flights/passengers" component={Passengers} />

                <Route path="/flights/review" component={Purchase} />
                <Route path="/flights/seats" component={Seats} />

                <Route path="/flights/confirmation" component={Confirmation} />
                <Route path="/flights/browse" component={FlightBrowse} />
                <Route path="/flights/:direction" component={FlightsHomeDates} />
                <Route path="/flights" component={FlightsHome} />

                <Route path="/flight/:id/:direction" component={FlightPage} />

                {/* catch all goes to the homepage instead of 404 */}
                <Route component={Home} /> 
              </Switch>

              
              

            </div>
          </ScrollToTop>
        </Router>
      </Provider>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.jsx